export default "__VITE_ASSET__DEFuAsqI__"